interface UserMessageProps {
  message: string;
}

const componentContainer = "flex flex-col justify-center items-end gap-2.5 self-stretch ml-4.5";
const messageContainer = "flex w-full p-3 flex-col justify-end items-start gap-2.5 rounded-md rounded-tr-none bg-loch";
const textStyles = "text-neutral-white whitespace-pre-wrap text-small-body-md tracking-normal";

export const PropertyPalUserMessage = (props: UserMessageProps) => {
  return (
    <div className={componentContainer}>
      <div className={messageContainer}>
        <div className={textStyles}>{props.message}</div>
      </div>
    </div>
  );
};
